export enum LocationConnectionStatus {
  Offline = 0,
  Online = 1
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/enums/locationConnectionStatus.ts